import React, { JSX, PropsWithChildren, ReactNode } from 'react'
import './index.scss'

interface ContentHeaderProps {
    title: ReactNode
    subTitle?: string
    descriptionElement?: string | JSX.Element
    content?: ReactNode
    navLeft?: ReactNode
    navRight?: ReactNode
}

const ContentHeader = (props: PropsWithChildren<ContentHeaderProps>) => {
    const { title, subTitle, descriptionElement, content, navLeft, navRight, children } = props

    return (
        <div className="content-header">
            <div className="sub-nav-container">
                {navLeft && <div className="sub-nav-left">{navLeft}</div>}
                {navRight && <div className="sub-nav-right">{navRight}</div>}
            </div>
            <div className="data-container">
                <div className="left-data">
                    <h2>{title}</h2>
                    {subTitle && <h4> - {subTitle}</h4>}
                    {descriptionElement && <div className="head-description">{descriptionElement}</div>}
                    {content && <div className="description-content"> {content} </div>}
                </div>
                <div className="right-data">{children}</div>
            </div>
        </div>
    )
}

export default ContentHeader
